import Cookies from 'js-cookie';
import isbot from 'isbot';

document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('.sitenotice').forEach(notice => {

    const noticeId = notice.getAttribute('id');
    const expiresHours = notice.getAttribute('data-expires') ? parseFloat(notice.getAttribute('data-expires')) : 2;
    const expiresDays = expiresHours / 24;

    function init() {
      if (!isbot(navigator.userAgent)) {
        if (Cookies.get(noticeId) == undefined) {
          open();
        }
      }
    }

    function open() {
      notice.removeAttribute('hidden');
      document.querySelector('.container').classList.add('has-sitenotice');
    }

    function close() {
      notice.remove();
      document.querySelector('.container').classList.remove('has-sitenotice');
      Cookies.set(noticeId, 1, { expires: expiresDays });
    }

    if (notice.querySelector('.sitebanner-close')) {
      notice.querySelector('.sitebanner-close').addEventListener('click', (e) => {
        close();
        e.preventDefault();
        e.stopPropagation();
      });
    }

    init();


  });
});
